import { observer } from 'mobx-react-lite';
import React from 'react';
import './Footer.scss';

const Footer: React.FC = () => (
  <footer>
    <a
      href='mailto:potyasup@microsoft.com'
      target='_blank'
      rel='noopener noreferrer'
    >
      Contact us
    </a>
    <a
      href='http://go.microsoft.com/fwlink/?LinkId=248681'
      target='_blank'
      rel='noopener noreferrer'
    >
      Privacy and cookies
    </a>
    <a
      href='https://go.microsoft.com/fwlink/?linkid=2259814'
      target='_blank'
      rel='noopener noreferrer'
    >
      Consumer Health Privacy
    </a>
    <a
      href='http://www.microsoft.com/en-us/legal/intellectualproperty/copyright/default.aspx'
      target='_blank'
      rel='noopener noreferrer'
    >
      Terms of use
    </a>
    <a
      href='http://www.microsoft.com/library/toolbar/3.0/trademarks/en-us.mspx'
      target='_blank'
      rel='noopener noreferrer'
    >
      Trademarks
    </a>
    <span>{`@${new Date().getFullYear()} Microsoft`}</span>
  </footer>
);

export default observer(Footer);
